/**
 * Workspace domain helpers — used to gate Gmail API, calendar sync, etc.
 * App login itself is not domain-restricted; only integration features use these checks.
 */

export function normalizeWorkspaceDomain(domain) {
  return String(domain || '')
    .trim()
    .toLowerCase()
    .replace(/^@/, '')
}

export function getEmailDomain(email) {
  const lower = String(email || '')
    .trim()
    .toLowerCase()
  const at = lower.lastIndexOf('@')
  return at >= 0 ? lower.slice(at + 1) : ''
}

/**
 * True when the address is on the configured Workspace domain or a subdomain
 * of it (student accounts are often name@students.district.org). False if the
 * domain is unset or the email has no host. A lookalike host such as
 * notdistrict.org does not match.
 */
export function isWorkspaceEmail(email, workspaceDomain) {
  const domain = normalizeWorkspaceDomain(workspaceDomain)
  if (!domain) return false
  const emailDomain = getEmailDomain(email)
  if (!emailDomain) return false
  return emailDomain === domain || emailDomain.endsWith(`.${domain}`)
}

/** True when email exists and is not on the configured Workspace domain. */
export function isOutsideWorkspace(email, workspaceDomain) {
  const domain = normalizeWorkspaceDomain(workspaceDomain)
  if (!domain) return false
  const emailDomain = getEmailDomain(email)
  if (!emailDomain) return false
  return !isWorkspaceEmail(email, workspaceDomain)
}
